import { Component, EventEmitter, Inject, Input, Output } from 'ng-metadata/core';

@Component({
    selector: 'mw-content-stream-sort-menu',
    template: `
        <md-menu class="mw-menu mw-content-stream-sort-menu" md-position-mode="target-left target" md-offset="0 50">
            <mw-menu-trigger-icon-button icon="content:ic_sort_24px" tooltip="{{'Sort' | translate}}" on-click="$mdMenu.open($event)"></mw-menu-trigger-icon-button>
            <md-menu-content class="mw-menu-dropdown">
                <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
                <mw-menu-item  type="singleselect" aria-label="Date" on-click="$ctrl.handleSortBySelect('date')" is-selected="$ctrl.sortBy === 'date'"><translate translate="mw-content-stream-sort-menu__sort-by--date"></translate></mw-menu-item>
                <mw-menu-item  type="singleselect" aria-label="Reach" on-click="$ctrl.handleSortBySelect('reach')" is-selected="$ctrl.sortBy === 'reach'"><translate translate="mw-content-stream-sort-menu__sort-by--reach"></translate></mw-menu-item>
                <mw-menu-item  type="singleselect" aria-label="Sentiment" on-click="$ctrl.handleSortBySelect('sentiment')" is-selected="$ctrl.sortBy === 'sentiment'"><translate translate="mw-content-stream-sort-menu__sort-by--sentiment"></translate></mw-menu-item>
                <mw-menu-item  type="singleselect" aria-label="Geo" on-click="$ctrl.handleSortBySelect('geo')" is-selected="$ctrl.sortBy === 'geo'"><translate translate="mw-content-stream-sort-menu__sort-by--geo"></translate></mw-menu-item>
                <mw-menu-item  type="singleselect" aria-label="Relevance" on-click="$ctrl.handleSortBySelect('relevance')" is-selected="$ctrl.sortBy === 'relevance'"><translate translate="mw-content-stream-sort-menu__sort-by--relevance"></translate></mw-menu-item>
                <mw-menu-item  ng-if="$ctrl.socialEchoTop25" type="singleselect" aria-label="Social Echo" on-click="$ctrl.handleSortBySelect('socialecho')" is-selected="$ctrl.sortBy === 'socialecho'"><translate translate="mw-content-stream-sort-menu__sort-by--social-echo"></translate></mw-menu-item>
                <mw-menu-item  ng-if="$ctrl.socialEngagementEnabled" type="singleselect" aria-label="Social Engagement" on-click="$ctrl.handleSortBySelect('engagement')" is-selected="$ctrl.sortBy === 'engagement'"><translate translate="social_engagement--engagement"></translate></mw-menu-item>
                <md-divider class="mw-menu-divider"></md-divider>
                <mw-menu-item  type="singleselect" aria-label="Ascending" on-click="$ctrl.handleSortDirectionSelect('asc')" is-selected="$ctrl.sortDirection === 'asc'"><translate translate="mw-content-stream-sort-menu__sort-order--ascending"></translate></mw-menu-item>
                <mw-menu-item  type="singleselect" aria-label="Descending" on-click="$ctrl.handleSortDirectionSelect('desc')" is-selected="$ctrl.sortDirection === 'desc'"><translate translate="mw-content-stream-sort-menu__sort-order--descending"></translate></mw-menu-item>
            </md-menu-content>
        </md-menu>
    `
})

export class SortMenuComponent {
    @Input('<') sortBy: string;
    @Input('<') sortDirection: string;
    @Input('<') socialEchoTop25: boolean = false;
    @Input('<') socialEngagementEnabled: boolean = false;
    @Output() onSortByChange = new EventEmitter();
    @Output() onSortDirectionChange = new EventEmitter();

    constructor () {}

    handleSortDirectionSelect(sortDirection) {
        this.onSortDirectionChange.emit(sortDirection);
    }

    handleSortBySelect(sortBy) {
        this.onSortByChange.emit(sortBy);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-stream/sort-menu/sort-menu.component.ts